export const formatDate = (timestamp) => {
  const date = new Date(timestamp * 1000); // Convertir le timestamp en millisecondes
  const day = String(date.getDate()).padStart(2, '0'); // Ajouter un zéro si nécessaire
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Les mois commencent à 0 en JavaScript
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};
